import type { PeriodPickerSegment, PeriodPickerValue } from '@/shared/components/ui';
import { customRangeToIso } from '@/shared/utils/customPeriodRange';

import type { AnalyticsDateRange, AnalyticsPeriod } from '../services/agentAnalyticsApi';

/**
 * Período das abas Análises / Saúde / Lacunas do agente — mesma régua nas
 * três (Personalizado desde 2026-10-16).
 */
export const ANALYTICS_PERIOD_SEGMENTS: ReadonlyArray<PeriodPickerSegment<AnalyticsPeriod>> = [
  { key: '1d', label: 'Últimas 24h' },
  { key: '7d', label: '7 dias' },
  { key: '30d', label: '30 dias' },
  { key: '90d', label: '90 dias' },
];

export const DEFAULT_ANALYTICS_PERIOD: AnalyticsPeriod = '7d';

export type AnalyticsPeriodValue = PeriodPickerValue<AnalyticsPeriod>;

/** O que vai para a API: o `period` e, no Personalizado, o intervalo. */
export interface AnalyticsPeriodQuery {
  period: AnalyticsPeriod;
  range?: AnalyticsDateRange;
}

/**
 * Valor do seletor → consulta. Personalizado manda o intervalo (do primeiro
 * dia inteiro ao último dia inteiro, no fuso do navegador) e o `period`
 * padrão — o backend ignora o `period` quando há intervalo, e mantê-lo fixo
 * evita que a mesma escolha vire duas entradas de cache.
 */
export const toAnalyticsPeriodQuery = (value: AnalyticsPeriodValue): AnalyticsPeriodQuery => {
  if (value.mode !== 'custom') return { period: value.mode };
  if (value.start && value.end) {
    return { period: DEFAULT_ANALYTICS_PERIOD, range: customRangeToIso(value.start, value.end) };
  }
  // Personalizado sem as duas datas não sai do seletor; cai no padrão.
  return { period: DEFAULT_ANALYTICS_PERIOD };
};
